import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { apiAxios } from '@/api'
import { fetchWrapper } from '@/reducers/fetch'
import {
  BankingProfile,
  EnsureBankingProfileResponse,
  GetBankingProfileResponse,
} from './banking.types'

export type BankingState = {
  profile: BankingProfile | null
}

const initialState: BankingState = {
  profile: null,
}

const bankingSlice = createSlice({
  name: 'banking',
  initialState,
  reducers: {
    receiveBankingProfile: (state, action: PayloadAction<BankingProfile>) => {
      state.profile = action.payload
    },
    clearBankingProfile: (state) => {
      state.profile = null
    },
  },
})

export default bankingSlice.reducer
export const { receiveBankingProfile, clearBankingProfile } =
  bankingSlice.actions

export const ENSURE_BANKING_PROFILE_KEY = 'ENSURE_BANKING_PROFILE_KEY'
export const FETCH_BANKING_PROFILE_KEY = 'FETCH_BANKING_PROFILE_KEY'

export const ensureBankingProfile = () =>
  fetchWrapper({
    fetchKey: ENSURE_BANKING_PROFILE_KEY,
    fetchFunction: async (dispatch) => {
      const res = await apiAxios.post<EnsureBankingProfileResponse>(
        '/finances/api/v1/banking/profile',
        {}
      )
      dispatch(receiveBankingProfile(res.data.bankingProfile))
      return res.data.bankingProfile
    },
  })

export const fetchBankingProfile = () =>
  fetchWrapper({
    fetchKey: FETCH_BANKING_PROFILE_KEY,
    fetchFunction: async (dispatch) => {
      const res = await apiAxios.get<GetBankingProfileResponse>(
        '/finances/api/v1/banking/profile'
      )
      if (res.data.bankingProfile) {
        dispatch(receiveBankingProfile(res.data.bankingProfile))
      }
      return res.data.bankingProfile
    },
  })
